import { Box as p } from "@mui/material";
import { jsx as d } from "react/jsx-runtime";
import { forwardRef as c } from "react";
import a from "@mui/material/Tab";
import { T as e } from "./Tooltip-CKVc9519.js";
var g = /* @__PURE__ */ ((r) => (r.grey = "grey", r.primary = "primary", r.error = "error", r.warning = "warning", r.success = "success", r.indigo = "indigo", r.purple = "purple", r.pink = "pink", r.rose = "rose", r))(g || {}), f = /* @__PURE__ */ ((r) => (r.contained = "contained", r.outlined = "outlined", r.text = "text", r.underline = "underline", r))(f || {}), s = /* @__PURE__ */ ((r) => (r.sm = "sm", r.md = "md", r))(s || {}), v = /* @__PURE__ */ ((r) => (r.xs = "xs", r.small = "small", r.medium = "medium", r.large = "large", r.xl = "xl", r.xxl = "xxl", r))(v || {}), w = /* @__PURE__ */ ((r) => (r.xs = "xs", r.small = "small", r.medium = "medium", r.large = "large", r.xl = "xl", r.xxl = "xxl", r))(w || {}), b = /* @__PURE__ */ ((r) => (r[r.bold = 700] = "bold", r[r.semibold = 600] = "semibold", r[r.medium = 500] = "medium", r[r.regular = 400] = "regular", r))(b || {}), k = /* @__PURE__ */ ((r) => (r.contained = "contained", r.outlined = "outlined", r.text = "text", r))(k || {}), j = /* @__PURE__ */ ((r) => (r.small = "small", r.medium = "medium", r.large = "large", r))(j || {}), y = /* @__PURE__ */ ((r) => (r.text = "text", r.button = "button", r))(y || {}), H = /* @__PURE__ */ ((r) => (r.arrow = "arrow", r.slash = "slash", r))(H || {});
const G = c(
  (r, i) => {
    const { tooltip: l, ...x } = r;
    return !l || !l.title && !l.text ? /* @__PURE__ */ d(
      a,
      {
        ref: i,
        ...x
      }
    ) : /* @__PURE__ */ d(p, { sx: { ...x.sx }, children: /* @__PURE__ */ d(
      e,
      {
        title: l.title,
        text: l.text,
        placement: l.placement,
        shouldHighlightChildIcon: !1,
        children: /* @__PURE__ */ d(
          a,
          {
            ref: i,
            ...x
          }
        )
      }
    ) });
  }
);
export {
  f as C,
  G as T,
  s as a,
  w as b,
  v as c,
  g as d,
  b as e,
  k as f,
  j as g,
  y as h,
  H as i
};
